export function getApplicantTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'UTC';
  }
}

/**
 * Convert a wall-clock date/time in a source timezone to display strings in a target timezone.
 * Works entirely in the browser using Intl API.
 */
/**
 * Convert a wall-clock date/time in a source timezone to a JavaScript UTC Date object.
 */
export function zonedToUtc(dateStr: string, timeStr: string, timeZone: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  const [hour, minute] = timeStr.split(':').map(Number);
  let d = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));
  for (let i = 0; i < 3; i++) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(d);
    const get = (t: string) => Number(parts.find((p) => p.type === t)!.value);
    const localMs = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
    const offset = d.getTime() - localMs;
    const adjusted = new Date(Date.UTC(year, month - 1, day, hour, minute, 0) + offset);
    if (adjusted.getTime() === d.getTime()) break;
    d = adjusted;
  }
  return d;
}

/**
 * Convert a wall-clock date/time in a source timezone to display strings in a target timezone.
 * Works entirely in the browser using Intl API.
 */
export function convertSlotToTimezone(
  date: string,
  time: string,
  sourceTz: string,
  targetTz: string
): { displayDate: string; displayTime: string } {
  const d = zonedToUtc(date, time, sourceTz);

  const displayTime = d.toLocaleTimeString('en-US', {
    timeZone: targetTz,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const displayDate = d.toLocaleDateString('en-US', {
    timeZone: targetTz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return { displayDate, displayTime };
}
